/*****************************************************/
/* 処　理：SMS001 メインメニュー 画面
/*
/* 概　要：定数定義
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/

// 処理名
export const INIT_NAME = '初期表示';
export const BTN_EXECUTE_NAME = '取引を行う';
export const CHANGE_LANGUAGE_NAME = '言語切替';

// APIパス
export const API_INIT_PATH = '/SMS001/init';
export const API_EXECUTE_PATH = '/SMS001/execute';

// 対応言語数
// ※対応言語が増えた場合、修正要
// ※message-origin.tsの言語区分(SMS999xxM999L)の定義数と合わせる
export const LANG_TYPE_UPPER_LIMIT = 3;
